class Accordion {
	constructor( detailsEl ) {
		// Store the <details> element
		this.detailsEl = detailsEl;
		// Store the <summary> element
		this.summaryEl = detailsEl.querySelector( '.accordion_head' );
		// Store the <div class="content"> element
		this.contentEl = detailsEl.querySelector( '.accordion_content' );

		// Store the animation object (so we can cancel it if needed)
		this.animation = null;
		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isExpanding = false;
		// Detect user clicks on the summary element
		this.summaryEl.addEventListener( 'click', ( ev ) => this.onClick( ev ) );
	}

	onClick( ev ) {
		// Stop default behaviour from the browser
		ev.preventDefault();
		// Add an overflow on the <details> to avoid content overflowing
		this.detailsEl.style.overflow = 'hidden';
		// Check if the element is being closed or is already closed
		if ( this.isClosing || ! this.detailsEl.open ) {
			this.open();
			// Check if the element is being openned or is already open
		} else if ( this.isExpanding || this.detailsEl.open ) {
			this.shrink();
		}
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true;

		// Store the current height of the element
		const startHeight = `${this.detailsEl.offsetHeight}px`;
		// Calculate the height of the summary
		const endHeight = `${this.summaryEl.offsetHeight}px`;

		// If there is already an animation running
		if ( this.animation ) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.detailsEl.animate( {
			// Set the keyframes from the startHeight to endHeight
			height: [startHeight, endHeight]
		}, {
			duration: 200, easing: 'ease-out'
		} );

		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish( false );
		// If the animation is cancelled, isClosing variable is set to false
		this.animation.oncancel = () => this.isClosing = false;
	}

	open() {
		// Apply a fixed height on the element
		this.detailsEl.style.height = `${this.detailsEl.offsetHeight}px`;
		// Force the [open] attribute on the details element
		this.detailsEl.open = true;
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame( () => this.expand() );
	}

	expand() {
		// Set the element as "being expanding"
		this.isExpanding = true;
		// Get the current fixed height of the element
		const startHeight = `${this.detailsEl.offsetHeight}px`;
		// Calculate the open height of the element (summary height + content height)
		const endHeight = `${this.summaryEl.offsetHeight + this.contentEl.offsetHeight}px`;

		// If there is already an animation running
		if ( this.animation ) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.detailsEl.animate( {
			// Set the keyframes from the startHeight to endHeight
			height: [startHeight, endHeight]
		}, {
			duration: 200, easing: 'ease-out'
		} );
		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish( true );
		// If the animation is cancelled, isExpanding variable is set to false
		this.animation.oncancel = () => this.isExpanding = false;
	}

	onAnimationFinish( open ) {
		// Set the open attribute based on the parameter
		this.detailsEl.open = open;
		// Clear the stored animation
		this.animation = null;
		// Reset isClosing & isExpanding
		this.isClosing = false;
		this.isExpanding = false;
		// Remove the overflow hidden and the fixed height
		this.detailsEl.style.height = '';
		this.detailsEl.style.overflow = '';
	}
}


const initAccordions = ( scopeEl = document ) => {
	const detailEls = scopeEl.querySelectorAll( 'details.accordion_item' );
	detailEls.forEach( ( detailsEl ) => {
		detailsEl.SL_Accordion ??= new Accordion( detailsEl );
	} );
}

export {
	Accordion as default,
	initAccordions
};
